module.exports = __webpack_public_path__ + "images/emoji/ticket.65fa8830a8b9597a1e57.png";